import { render, staticRenderFns } from "./tags-list.vue?vue&type=template&id=36716ea0&"
import script from "./tags-list.vue?vue&type=script&lang=js&"
export * from "./tags-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports